import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import axios from "../api/axios";

export default function Topcategories() {
  const [topCategories, setTopCategories] = useState([]);

  useEffect(() => {
    const fetchTopCategories = async () => {
      try {
        const response = await axios.get("/categories");
        setTopCategories(response.data);
      } catch (error) {
        console.error("Error fetching top categories:", error);
      }
    };

    fetchTopCategories();
  }, []);

  useEffect(() => {
    const initSwiper = () => {
      if (window.Swiper) {
        new window.Swiper(".brand-carousel1", {
          slidesPerView: 3,
          spaceBetween: 20,
          loop: false,
          navigation: {
            nextEl: ".brand-carousel-next",
            prevEl: ".brand-carousel-prev",
          },
          breakpoints: {
            320: { slidesPerView: 1 },
            768: { slidesPerView: 2 },
            992: { slidesPerView: 3 },
            1200: { slidesPerView: 4 },
          },
        });
      } else {
        setTimeout(initSwiper, 100);
      }
    };

    initSwiper();
  }, []);

  const cards = [
    "cat1.png",
    "cat2.gif",
    "cat3.gif",
    "cat4.png",
    "cat5.png",
    "cat6.png",
  ];

  return (
    <section className="py-1 overflow-hidden">
      <div className="container-fluid">
        <div className="row">
          <div className="col-md-12">
            <div className="section-header d-flex flex-wrap justify-content-between mt-5 py-3">
              <h3>Top categories on offer</h3>
            </div>

            <div className="brand-carousel1 swiper">
              <div className="swiper-wrapper">
                {topCategories.map((cat, i) => (cat.discount_image_url ? (
                  <div className="swiper-slide" key={i}>
                    <Link to={`/categories/${cat.id}`} style={{textDecoration:'none', color:'black'}}>
                      <div className="row g-0">
                        <div className="col-md-12">
                          <img
                            src={`${cat.discount_image_url}`}
                            className="img-fluid rounded"
                            alt="Brand Product"
                            style={{width:'100%'}}
                          />
                        </div>
                        <div className="col-md-12">
                          <div className="card-body py-0">
                            <p className="text-muted mb-0 text-center">{cat.name}</p>

                          </div>
                        </div>
                      </div>
                      </Link>
                  </div>
                ) : null
                ))}
              </div>
            </div>

          </div>
        </div>
      </div>
    </section>
  );
}
